// import { useState } from "react";

import Image from '@/components/image';
import { ProductListProvider } from '@/components/product-list-context';
import ProductListItem from '@/components/product-list-item';
import { PRODUCT_LISTS } from '@/utils/gtm/item-lists';
// import CurrencyIcon from '@/components/ui/icons/currency-icon';
// import { validatePrice } from '@/utils/category';

export default function ComboProductsList({ bundleProductOptions, t }) {
  // const [activePopover, setActivePopover] = useState(null);
  const bundleProducts =
    bundleProductOptions?.map((b) => b.product_links)?.flat() || [];

  // const togglePopover = (id) => {
  //   setActivePopover((prev) => (prev === id ? null : id));
  // };

  return (
    bundleProductOptions && (
      <ProductListProvider list={PRODUCT_LISTS.pdpCombo}>
        <main className='w-full bg-[#f8fafc] text-[#0f172a]'>
          <section className='border-border-50 relative overflow-hidden rounded-xl border bg-white pt-10'>
            {/* Header */}
            <div className='border-border-50 bg-primary/5 absolute top-0 right-0 left-0 flex items-center justify-start gap-2 border-b px-3 py-2'>
              <h1 className='text-primary m-0 text-[15px] font-semibold tracking-wide'>
                {t('Combo offer')}
              </h1>
            </div>

            {/* Product List */}
            {bundleProducts?.map((p, index) => {
              const productImage = p?._media_?.image?.at(0)?.image || '';
              // const price = validatePrice(p?.prices_with_tax);
              return (
                <ProductListItem
                  as='article'
                  product={p}
                  index={index}
                  key={p.id}
                  className='border-border-50 relative grid grid-cols-[76px_1fr_32px] items-center gap-2.5 border-b p-2.5 text-left last:border-none'
                >
                  {/* Image */}
                  <div className='order-1 aspect-square w-[76px]'>
                    <Image
                      width={76}
                      height={76}
                      src={productImage}
                      alt={p.name}
                      loading='lazy'
                      className='h-full w-full rounded-md bg-[#f1f5f9] object-contain text-start text-xs'
                    />
                  </div>

                  {/* Product Info */}
                  <div className='order-2 flex min-w-0 flex-col gap-1 text-start'>
                    <h2 className='hover:text-primary truncate text-[14px] leading-snug font-medium text-[#1e293b] transition-colors duration-200 md:text-[15px]'>
                      {p?.name}
                    </h2>
                    {/* Prices */}
                    {/* <div className="flex gap-4">
                    <div className="text-[14px] flex gap-1 items-center font-semibold text-[#334155]">
                    <CurrencyIcon className='size-3'/> {price.originalPrice}
                  </div>
                     {price?.discount && <div className="text-[14px] flex gap-1 items-center font-semibold text-[#6B7280] line-through">
                      <CurrencyIcon className='size-3' /> {price.specialPrice || price.originalPrice} 
                     </div>} 
                  </div>
                     */}
                    <div className='text-[12px] font-normal text-[#64748b]'>
                      {t('Quantity')}:{' '}
                      {Number(p.bundle_child_default_stock)?.toFixed(0)}
                    </div>
                  </div>

                  {/* Info Button + Popover */}
                  <div className='relative order-3 flex justify-center'>
                    {/* <button
                onClick={() => togglePopover(p.id)}
                className="border border-[#e5e7eb] bg-white w-[28px] h-[28px] rounded-full grid place-items-center cursor-pointer transition-all hover:bg-[#1e2b55]/10 hover:border-[#1e2b55]/30"
                aria-label="Product Info"
                aria-expanded={activePopover === p.id}
              >
                <span className="inline-block w-[16px] h-[16px] rounded-full bg-[#334155] text-white text-[10px] font-semibold leading-[16px] text-center">
                  i
                </span>
              </button> */}

                    {/* {activePopover === p.id && (
                <div className="absolute right-10 top-1/2 -translate-y-1/2 z-20 bg-white border border-[#e5e7eb] rounded-lg p-3 w-[260px] shadow-sm">
                  <button
                    onClick={() => setActivePopover(null)}
                    className="absolute top-2 right-2 bg-[#475569] text-white w-[18px] h-[18px] rounded-full text-[12px] font-medium leading-[18px] text-center"
                    aria-label="Close"
                  >
                    ×
                  </button>
                  <h3 className="m-0 text-[13px] font-semibold text-[#1e2b55] mb-1">
                    Product Benefit
                  </h3>
                  <p className="text-[12px] text-[#475569] leading-[1.5] m-0 font-normal">
                    {p.benefit}
                  </p>
                </div>
              )} */}
                  </div>
                </ProductListItem>
              );
            })}
          </section>
        </main>
      </ProductListProvider>
    )
  );
}
